import React, { useState } from 'react';
import Button from '/react4xp/mixins/ui/button/button';
import {Form, Modal, Space, Typography, Upload} from 'antd';
import { ICategory } from '../../manage-reestr-list/manage-reestr-list.type';
import { CloseCircleOutlined } from '@ant-design/icons';
import {validateHistoryFile} from "/react4xp/parts/manage-reestr-item/actions";

interface ManageReestrValidateModalProps {
    isModalOpen: boolean;
    close: () => void;
    category: ICategory;
    translations: any;
}

const ManageReestrValidateModal = ({
    isModalOpen,
    category,
    close,
}: ManageReestrValidateModalProps) => {
    const [result, setResult] = useState<any>();
    const [form] = Form.useForm();

    const handleUpload = async options => {
        const { onSuccess, onError, file, onProgress } = options;

        const config = {
            headers: { "content-type": "multipart/form-data" },
            params: {
                importDocumentCategory: category.documentCategory
            },
            onUploadProgress: event => {
                onProgress({ percent: (event.loaded / event.total) * 100 });
            },
        };

        const formData = new FormData();
        formData.append('file', file);

        try {
            await validateHistoryFile(formData, config);
            setResult({
                status: 'success',
            });
            onSuccess("Ok");
        } catch (error) {
            const {errorParams} = error.response.data;

            if (errorParams) {
                setResult({
                    status: 'error',
                    errorParams
                });
            }

            onError({ error });
        }
    };

    const handleClose = () => {
        form.resetFields();
        setResult(null);
        close();
    };

    return (
        <Modal
            title="Проверить правильность файла"
            open={isModalOpen}
            onCancel={handleClose}
            footer={[
                <Button
                    key="close"
                    type="primary admin"
                    onClick={handleClose}
                >
                    Закрыть
                </Button>,
            ]}
        >
            <div className="my-3">
                <Form
                    layout="vertical"
                    form={form}
                >
                    <Form.Item name="file">
                        <Upload maxCount={1} customRequest={handleUpload}>
                            <Button>Выберите файл</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </div>

            {result && (
                <Space direction="vertical">
                    <Typography.Title level={4}>
                        {result.status === 'success' ? 'Корректный файл' : 'Файл содержит ошибки'}
                    </Typography.Title>
                    <div>
                        {result.status === 'error' && result.errorParams.map(x => (
                            <Space>
                                <CloseCircleOutlined />
                                <span>
                                    {x.rowIndex && x.fields
                                        ? `Ошибка в строке ${x.rowIndex}, ${
                                            x.fields[0] === 'DUPLICATE'
                                                ? 'имеется дубликат'
                                                : 'невалидные поля: ' + x.fields.join(', ')
                                            }`
                                        : 'Проверьте формат файла'
                                    }
                                </span>
                            </Space>
                        ))}
                    </div>
                </Space>
            )}
        </Modal>
    );
};

export default ManageReestrValidateModal;
